import DividerLine from '../../../components/DividerLine';

import iconCaret from './../../../images/success/icon-caret.svg';
import iconFacebook from './../../../images/success/facebook.svg';
import iconYoutube from './../../../images/success/youtube.svg';
import iconTwitter from './../../../images/success/twitter.svg';
import iconLinkedIn from './../../../images/success/linkedin.svg';

declare const sp: any;

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    {
      url: 'https://www.facebook.com/EnphaseEnergy/',
      icon: iconFacebook,
      zukoId: 'link-facebook',
    },
    {
      url: 'https://www.youtube.com/user/EnphaseEnergy/',
      icon: iconYoutube,
      zukoId: 'link-youtube',
    },
    {
      url: 'https://twitter.com/Enphase/',
      icon: iconTwitter,
      zukoId: 'link-twitter',
    },
    {
      url: 'https://www.linkedin.com/company/enphase-energy/',
      icon: iconLinkedIn,
      zukoId: 'link-linkedin',
    },
  ];

  return (
    <div className="p-6 md:px-20 bg-white text-[11px] md:text-[12px] w-full">
      <div className="max-w-[1060px] m-auto">
        <div className="flex justify-between">
          <div className="flex">
            {links.map((link, index) => (
              <a
                key={index}
                className="w-8"
                target="_blank"
                href={link.url}
                rel="noreferrer"
                data-zuko-id={link.zukoId}>
                <img
                  className="social-icon m-auto w-full"
                  src={link.icon}
                  alt="social"
                />
              </a>
            ))}
          </div>
          <button
            type="button"
            className="text-enph-grey-02"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            data-zuko-id="button-back-to-top">
            <span>back to top</span>
            <img
              alt="back to top"
              src={iconCaret}
              className="inline-block ml-[10px]"
            />
          </button>
        </div>
        <DividerLine smallMarging={true}></DividerLine>
        <div className="flex justify-between flex-col lg:flex-row text-center gap-y-4 lg:gap-y-0 mt-[20px] text-enph-grey-02 lg:text-enph-dark-grey">
          <div>
            Copyright © {currentYear} Enphase Energy. All rights reserved.
          </div>
          <div className="flex flex-col lg:flex-row gap-y-4 lg:gap-y-0">
            <div>
              <a
                href="https://enphase.com/legal/terms-of-service"
                target="_blank"
                rel="noreferrer"
                className="mx-[8px]">
                Terms
              </a>
              <a
                href="https://enphase.com/legal/privacy-policy"
                target="_blank"
                rel="noreferrer"
                className="mx-[8px]">
                Privacy
              </a>
            </div>
            <div>
              <button
                type="button"
                onClick={() => sp.showPrivacyBanner()}
                className="mx-[8px]"
                data-zuko-id="button-settings-dont-share-my-info">
                Settings / Do Not Sell or Share My Personal Information
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
